import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { usePrefersReducedMotion } from '~/hooks/usePrefersReducedMotion';
import styles from './AnimatedPlaceholder.module.css';
const ANIMATION_DURATION = 3000;
const TRANSITION_DURATION = 500;
export function AnimatedPlaceholder() {
  const $ = _c(11);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t.raw("playground.animated_placeholder_options");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const placeholderOptions = t0 as string[];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();
  let t1;
  let t2;
  if ($[2] !== placeholderOptions.length || $[3] !== prefersReducedMotion) {
    t1 = () => {
      if (prefersReducedMotion) {
        const interval = setInterval(() => {
          setCurrentIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, ANIMATION_DURATION);
        return () => clearInterval(interval);
      }
      const interval_0 = setInterval(() => {
        setIsTransitioning(true);
        setTimeout(() => {
          setCurrentIndex(prevIndex_0 => (prevIndex_0 + 1) % placeholderOptions.length);
          setIsTransitioning(false);
        }, TRANSITION_DURATION / 2);
      }, ANIMATION_DURATION);
      return () => clearInterval(interval_0);
    };
    t2 = [prefersReducedMotion, placeholderOptions.length];
    $[2] = placeholderOptions.length;
    $[3] = prefersReducedMotion;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  const t3 = isTransitioning && !prefersReducedMotion;
  let t4;
  if ($[6] !== t3) {
    t4 = clsx(styles.dynamicText, {
      [styles.transitioning]: t3
    });
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = placeholderOptions[currentIndex];
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <span className={styles.animatedPlaceholder}><div className={styles.dynamicTextContainer}><span className={t4}>{t5}</span></div></span>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}